import axios from 'axios'
import qs from 'qs'
const appInfo = require('../../../AppInfo');
let httpProxy = appInfo.HTTP_PROXY;

export default {
  domain () {
    return httpProxy;
  },
  get(url) {
    return axios.get(url)
  },
  post(url, data) {
    data = qs.stringify(data);
    return axios.post(httpProxy + '/' + url, data)
  },
  uploadFiles(url,data) {
    return axios.post(httpProxy + '/' + url, data,{headers: {'Content-Type': 'multipart/form-data'}})
  },
}
